import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-info d-flex flex-column justify-center" }
const _hoisted_2 = { class: "card-info-title" }
const _hoisted_3 = { class: "card-info-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_tooltip, {
      disabled: !_ctx.displayTooltip,
      location: "top center",
      origin: "auto",
      "no-click-animation": ""
    }, {
      activator: _withCtx(({ props: tooltip }) => [
        _createElementVNode("div", _mergeProps(tooltip, {
          class: "plot-card",
          style: { backgroundImage: `url(${_ctx.cardImageUrl})` }
        }), null, 16)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(`cardsInfo.${_ctx.cardName}`)), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`cardsInfo.${_ctx.cardName}Hint`)), 1)
        ])
      ]),
      _: 1
    }, 8, ["disabled"])
  ]))
}